// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__x2T1H","label":"Category_label__39gMw","content":"Category_content__1T7B8","header":"Category_header__3ni0U","location":"Category_location__VsyNf"};